import React, { ReactElement } from 'react';
import { Link } from "react-router-dom";
import close from '../../../assets/images/close.png';
import noProfilePhoto from '../../../assets/images/no-profile-photo.png';
import suitcase from '../../../assets/images/suitcase.png';
import menu from '../../../assets/images/menu.png';
import Consumers from "../../../../constants/Consumers";
import MenuIcon from "./MenuIcon";
import cart from "../../../assets/images/cart.png";
import SendToTnAccountContainer from "../../../../auth/SendToTnAccount";
import circledMenu from "../../../assets/images/circled-menu.png";
import { useSelector } from "react-redux";
import { AppState } from "../../../../app/store/rootReducers";

interface Props {
  numberOfOrderItems: number;
  menuVisibility: boolean;
  showLogin: boolean;
  isLoggedIn: boolean;
  showLoginMenu: (name: string) => void;
  openMenu: () => void;
  closeMenu: () => void;
  isMenuOpen: boolean;
  section: string;
}


const MobileHead: React.FC<Props> = (props: any): ReactElement => {
  const { isLoggedIn, showLogin, showLoginMenu, isMenuOpen, closeMenu, numberOfOrderItems, section, openMenu } = props;
  const user = useSelector((state: AppState) => state.session.user);

  const renderMenuIcons = () => {
    if (section === Consumers.PRIVATE_CONSUMER) {
      if (isLoggedIn) {
        return <MenuIcon
          showLogin={showLogin}
          showLoginMenu={showLoginMenu}
          isConsumer={true}
          alt={'account'}
          src={user.avatarUrl ?? noProfilePhoto}
          numberOfOrderItems={numberOfOrderItems}
        />;
      }
      // not logged in
      return (
        <>
          <a href={process.env.REACT_APP_CART_OVERVIEW_NEW_URL}>
            <span className="list-item fw-bold">
              <img
                alt="cart"
                className="icon"
                src={cart}
              />
              {Boolean(numberOfOrderItems) && (
                <span className="cart-icon-number p-1 px-2">
                  {numberOfOrderItems}
                </span>
              )}
            </span>
          </a>
          <div className='my-auto' onClick={() => showLoginMenu("circled-menu")}>
            <img
              alt="circled-menu"
              className="icon mx-auto d-block"
              src={circledMenu}
            />
          </div>
          <SendToTnAccountContainer  from={window.location.href} isTextVisible={false} isIconWhite={false}/>
        </>
      );
    }
    // Business Consumer
    return <MenuIcon
      href="https://www.yettel.rs/sr/biznis"
      isConsumer={false}
      showLoginMenu={showLoginMenu}
      alt={'suitcase'}
      src={suitcase}
    />;
  };

  return (
    <div className="container">
      <div className={'row lime-background shadow-border me-0 ms-0 pb-1'}>
        <div className={'col-sm-4 col-4 p-0 text-center'}>
          <Link to={`/`}className="logo-link">
            <span className="yettel-bold-font">Yettel.</span>
          </Link>
        </div>
        <div className="col-sm-8 col-8 p-0 pe-3 text-center d-flex justify-content-end align-items-center">
          {renderMenuIcons()}
          <div>
            {
              isMenuOpen ? <img
                alt={'close'}
                className="icon d-block pull-right closeImg ms-2"
                src={close}
                onClick={closeMenu}
              /> : <React.Fragment>
                <a onClick={openMenu}>
                  <img
                    alt="menu-icon"
                    className="icon ms-2 d-block pull-right"
                    src={menu}
                  />
                </a>
              </React.Fragment>
            }
          </div>
        </div>
      </div>
    </div>
  );
};

export default MobileHead;
